angular.module('tgaAdmin').controller('DomainController', [
  '$scope',
  '$state',
  'domainService',
  'flashService',
  'modalService',
  '$translate',
  function ($scope, $state, domainService, flashService, modalService, $translate) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      domain_id: $state.params.domain_id || null,
      settings: [
        {
          key: 'display_sso',
          description: 'Whether to display Single Sign-On authentication option.',
          label: 'Display Single Sign-On',
        },
        {
          key: 'display_custom_privacy',
          description: 'Whether to display the custom privacy field in the game form.',
          label: 'Display Custom Privacy',
        },
        {
          key: 'display_question_list',
          description: 'Allow access to question list functionailty.',
          label: 'Display Question Lists',
        },
        {
          key: 'leaderboard_control',
          description: 'Allow toggling global leaderboard in Arcades.',
          label: 'Display Global Leaderboard',
        },
        {
          key: 'spintowin_control',
          description: 'Allow toggling Spin-To-Win in Arcades.',
          label: 'Display Global Spin-To-Win',
        },
        {
          key: 'arcade_email_logo_bottom',
          description: 'Allow moving the arcades logo to the bottom of the email.',
          label: 'Move Arcade Email Logo',
        },
        {
          key: 'success_factors_scorm',
          description: 'Show SAP Success Factors SCORM.',
          label: 'SAP Success Factors SCORM',
        },
        {
          key: 'enable_docebo_integration',
          description: 'Enable the ability to publish directly to the Docebo platform',
          label: 'Enable Docebo Integration',
        },
      ],
    };

    $scope.viewmodel = {
      domain: {},
      notes: [],
      settings: {
        display_sso: false,
        display_custom_privacy: false,
        display_question_list: false,
        display_arcades: false,
        leaderboard_control: false,
        spintowin_control: false,
        enable_docebo_integration: false,
      },
    };

    $scope.initialize = function () {
      $scope.loading = true;

      if ($scope.data.domain_id) {
        domainService.getDomain($scope.data.domain_id).then((domain) => {
          $scope.viewmodel.domain = domain;
          $scope.title = `<span class="text-muted">Domains /</span> ${$scope.viewmodel.domain.name}`;
          $scope.loading = false;
          domainService.getDomainStats($scope.viewmodel.domain.name).then((stats) => {
            $scope.viewmodel.stats = stats;
          });
        });

        domainService.getDomainNotes($scope.data.domain_id).then((notes) => {
          $scope.viewmodel.notes = notes;
        });

        domainService.getDomainSettings($scope.data.domain_id).then((settings) => {
          const keys = $scope.data.settings.map((s) => s.key);

          keys.forEach((key) => {
            if (settings[key]) {
              $scope.viewmodel.settings[key] = true;
            }
          });
        });
      }
    };

    $scope.actions = {
      deleteDomain() {
        modalService
          .showModal(
            {
              title: 'Delete Domain?',
              message: 'Are you sure you want to delete this domain?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;
              domainService.deleteDomain($scope.data.domain_id).then(
                () => {
                  flashService.set('<span class="fa fa-check"></span> Domain deleted.', 'success');
                  $state.go('v1.domains');
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  $scope.deleting = false;
                },
              );
            },
            () => {},
          );
      },
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        if ($scope.data.domain_id) {
          domainService.updateDomain($scope.viewmodel.domain).then(
            () => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> Domain updated.', 'success');
              $scope.processing = false;
              form.submitted = false;
              $scope.initialize();
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        } else {
          domainService.addDomain($scope.viewmodel.domain).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Domain created.', 'success');
              $state.go('v1.domains');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      addNote(form) {
        form.submitted = true;

        if (form.$invalid) {
          return;
        }

        form.processing = true;

        domainService
          .addDomainNote({ domain_id: $scope.data.domain_id, text: $scope.viewmodel.note })
          .then((notes) => {
            $scope.viewmodel.notes = notes;
            $scope.actions.createAlert('<span class="fa fa-check"></span> Note saved.', 'success');
            form.processing = false;
            form.submitted = false;
            $scope.viewmodel.note = null;
          })
          .catch((error) => {
            form.processing = false;
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
          });
      },
      updateSettings(form) {
        form.submitted = true;

        if (form.$invalid) {
          return;
        }

        form.processing = true;

        domainService
          .updateDomainSettings({ domain_id: $scope.data.domain_id, ...$scope.viewmodel.settings })
          .then(() => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Settings saved.', 'success');
            form.processing = false;
            form.submitted = false;
          })
          .catch((error) => {
            form.processing = false;
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
